import { forwardRef } from "react"
import PhoneInput from "react-phone-number-input/input"

import Input from "@molecules/Form/inputs/Input/Input"
import { InputProps } from "@molecules/Form/inputs/Input/Input.types"

import { PhoneNumberInputProps } from "./PhoneNumberInput.types"

function PhoneNumberInput<T>(props: PhoneNumberInputProps & InputProps<T>, ref: React.Ref<HTMLInputElement>) {
    const { defaultCountryCode = "US", ...rest } = props

    return (
        <Input
            ref={ref}
            type="tel"
            renderInputComponent={({ value, onChange, ...props }) => (
                <PhoneInput
                    defaultCountry={defaultCountryCode}
                    placeholder="(000) 000-0000"
                    value={value}
                    onChange={(value) =>
                        onChange({
                            target: {
                                value: value,
                            },
                        } as unknown as React.ChangeEvent<HTMLInputElement>)
                    }
                    {...props}
                />
            )}
            {...rest}
        />
    )
}

interface PhoneNumberInputComponent {
    <T>(
        props: PhoneNumberInputProps & InputProps<T> & React.RefAttributes<HTMLInputElement>,
    ): React.ReactElement | null
    displayName?: string
}

const PhoneNumberInputWithRef = forwardRef(PhoneNumberInput) as unknown as PhoneNumberInputComponent
PhoneNumberInputWithRef.displayName = "Input"

export default PhoneNumberInputWithRef
